import { RecordViewList } from "web/components"

import Tile from "../../Tile/Tile"

export default function TopicsTile({
  tileId,
  title,
  data,
  breakoutLink,
  fields,
  handleTileSettings,
  handleOnHide,
  showDummyData,
  canEdit = true,
  isDoubleColumn,
}) {
  return (
    <Tile
      canEdit={canEdit}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileId}
      title={title}
      breakoutLink={breakoutLink}
    >
      <RecordViewList
        data={data}
        fields={fields}
        emptyMessage="There are no Models for this Deal."
        showDummyData={showDummyData}
        isDoubleColumn={isDoubleColumn}
      />
    </Tile>
  )
}
